import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AutomationFlowLabelsAPI from '../../api/automationFlowLabels';
import { throwErrorMessage } from '../utils/api';

// Store do catálogo PRÓPRIO de etiquetas de fluxo (#1197). Espelha o de
// diretórios de fluxo linha a linha — inclusive a decisão de engolir o erro do
// `get` — porque as duas resolvem o mesmo problema na mesma tela.
export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getAutomationFlowLabels(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_AUTOMATION_FLOW_LABEL_UI_FLAG, { isFetching: true });
    try {
      const response = await AutomationFlowLabelsAPI.get();
      commit(types.SET_AUTOMATION_FLOW_LABELS, response.data.payload || []);
    } catch (error) {
      // A tela de fluxos abre sem etiquetas em vez de não abrir: durante a
      // janela do hook PostSync as tabelas ainda não existem, e um erro aqui
      // não pode derrubar a listagem, que é o assunto principal da tela.
      commit(types.SET_AUTOMATION_FLOW_LABELS, []);
    } finally {
      commit(types.SET_AUTOMATION_FLOW_LABEL_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, payload) => {
    commit(types.SET_AUTOMATION_FLOW_LABEL_UI_FLAG, { isCreating: true });
    try {
      const response = await AutomationFlowLabelsAPI.create(payload);
      commit(types.ADD_AUTOMATION_FLOW_LABEL, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_AUTOMATION_FLOW_LABEL_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...payload }) => {
    commit(types.SET_AUTOMATION_FLOW_LABEL_UI_FLAG, { isUpdating: true });
    try {
      const response = await AutomationFlowLabelsAPI.update(id, payload);
      commit(types.EDIT_AUTOMATION_FLOW_LABEL, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_AUTOMATION_FLOW_LABEL_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_AUTOMATION_FLOW_LABEL_UI_FLAG, { isDeleting: true });
    try {
      await AutomationFlowLabelsAPI.delete(id);
      commit(types.DELETE_AUTOMATION_FLOW_LABEL, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_AUTOMATION_FLOW_LABEL_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_AUTOMATION_FLOW_LABEL_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_AUTOMATION_FLOW_LABELS](_state, data) {
    _state.records = data || [];
  },
  [types.ADD_AUTOMATION_FLOW_LABEL]: MutationHelpers.create,
  [types.EDIT_AUTOMATION_FLOW_LABEL]: MutationHelpers.update,
  [types.DELETE_AUTOMATION_FLOW_LABEL]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
